<div class="container" (click)="select.open()">
  <div class="content" [ngClass]="{ 'has-value': hasValue() }">
    <p class="label">{{ label }}</p>
    <p class="value">{{ getFormatedValue() }}</p>
  </div>
  <mat-icon>keyboard_arrow_down</mat-icon>

  <mat-select #select [formControl]="control" [multiple]="isMultiple" [panelClass]="panelClass" [compareWith]="compareFilterObjects">
    <mat-option #allSelected *ngIf="isMultiple" (click)="toggleAllSelection()" [value]="{ id: null, name: 'ALL' }">
      ALL
    </mat-option>
    <mat-option *ngFor="let item of optionsArray" [value]="item">
      {{ getOptionValue(item) }}
    </mat-option>
  </mat-select>
</div>
